import React, { useState } from 'react';
import Step1TipoPessoa from './step1';
//import Step2TipoCertificado from './step2';
import Step3Estado from './step3';
import Step4CertificadoEspecifico from './step4';
import FormSPFisico from './step5/ESTADUAL/SP/fisico';
import FormSPJuridico from './step5/ESTADUAL/SP/juridico';
import styles from './consult.module.css'
import Stepper from './Stepper'

const STEP_SEQUENCE = [1, 3, 4, 5];

function Consult() {
    const [step, setStep] = useState(1);
    const [tipoPessoa, setTipoPessoa] = useState('');
    const [tipoCertificado, setTipoCertificado] = useState('');
    const [estado, setEstado] = useState('');
    //const [certificadoEspecifico, setCertificadoEspecifico] = useState('');
    const [certificadosSelecionados, setCertificadosSelecionados] = useState([]);
    const displayStep = STEP_SEQUENCE.indexOf(step) + 1;
    const totalDisplaySteps = STEP_SEQUENCE.length;

    const handleCompleteStep = (value, nextStep) => {
        console.log(`Passo: ${step}, Valor recebido: ${value}`);
        switch(step) {
            case 1:
                setTipoPessoa(value);
                break;
            //case 2:
                //setTipoCertificado(value);
               // break;
            case 3:
                setEstado(value);
                break;
            case 4:
                setCertificadosSelecionados(value);
                break;
            default:
                break;
        }
        setStep(nextStep);
    };

    const handleBackStep = () => {
    const idx = STEP_SEQUENCE.indexOf(step);
    if (idx > 0) {
        setStep(STEP_SEQUENCE[idx - 1]);
    }
    };

    const renderStep = () => {
        switch(step) {
            case 1:
                return <Step1TipoPessoa onComplete={(value) => handleCompleteStep(value, 3)} />;
            //case 2:
                //return <Step2TipoCertificado onComplete={(value) => handleCompleteStep(value, 3)} onBack={handleBackStep} />;
            case 3:
                return <Step3Estado /*tipoCertificado={tipoCertificado}*/ onComplete={(value) => handleCompleteStep(value, 4)} onBack={handleBackStep} />;
            case 4:
                return <Step4CertificadoEspecifico 
                            //tipoCertificado={tipoCertificado} 
                            estado={estado}
                            tipoPessoa={tipoPessoa} 
                            onComplete={(value) => handleCompleteStep(value, 5)} 
                            onBack={handleBackStep}
                        />;
            case 5:
                return (
                    <div>
                        {chooseFormulario()}
                        <button className={styles.backButton} onClick={handleBackStep}>Voltar</button>
                    </div>
                );
            default:
                return <div>Revisão das escolhas ou conclusão do processo</div>;
        }
    };

    const chooseFormulario = () => {
    return tipoPessoa === 'Físico'
        ? <FormSPFisico certificadosSelecionados={certificadosSelecionados} />
        : <FormSPJuridico certificadosSelecionados={certificadosSelecionados} />;
    };

        return (
        <div className={styles.consultPage}>
        {/* Título geral acima do stepper */}
        <h1 className={styles.mainTitle}>Solicitar certidão</h1>

        {/* Linha de passos */}
        <Stepper
        totalSteps={totalDisplaySteps}
        currentStep={displayStep}
        />

        {/* Conteúdo do passo atual */}
        {renderStep()}
        </div>
    );
}

export default Consult;
